import NetworkUtils from '@/custom/classes/network_utils.js'

class VettingRecipeHelper {
  constructor (applicant_id) {
    this.applicant_id = applicant_id
    this.network_utils = new NetworkUtils()
  }

  getPopulatedRecipe (params) {
    return new Promise((resolve, reject) => {
      let requests = [
        this.network_utils.getApplicantEducations({ current_applicant_id: this.applicant_id }),
        this.network_utils.getApplicantHistoryCompanies({ current_applicant_id: this.applicant_id }),
        this.network_utils.getApplicantSkills({ current_applicant_id: this.applicant_id })
      ]
      this.network_utils.caller.axios.all(requests).then(response => {
        const skills_obj = response[2].map(item => item.skill).reduce((prev, curr) => {
          const category = curr.category.toLowerCase().replaceAll(' ', '_')
          const exist = prev[`${category}_skills`] ? prev[`${category}_skills`].split(', ') : []
          prev[`${category}_skills`] = [...exist, curr.name].join(', ')
          return prev
        }, {})
        let replacement_dictionary = Object.assign({
          EDUCATIONS: this.getEducationsText(response[0], params.gender),
          HISTORY_COMPANIES: this.getHistoryCompaniesText(response[1], params.gender),
          CERTIFICATION_DATE: params.certification_date
        }, this.toLowerKeys(skills_obj))
        // https://stackoverflow.com/questions/5334380/replacing-text-inside-of-curley-braces-javascript
        let returned_recipe = params.recipe_data[`recipe_${params.gender}`].replace(/{(.*?)}/g, (match, offset) => replacement_dictionary[offset] || '')
        resolve(returned_recipe)
      })
    })
  }

  getEducationsText (educations, gender) {
    let text = ''
    for (let i = 0; i < educations.length; i++) {
      let education = educations[i]
      let with_honors = education.with_honors ? ' ^^בהצטיינות^^' : ''
      let grade = education.grade != undefined && !isNaN(education.grade) ? ' (' + education.grade + ')' : ''
      if (i > 0 && i != educations.length - 1) {
        text += ', '
      }
      if (i == educations.length - 1 && i != 0) {
        text += ' ו'
      }
      text += `${gender == 'female' ? 'בוגרת' : 'בוגר'} ${education.education_degree.name} ב${education.education_course.name} מ${education.education_institution.name}${grade}${with_honors}`
    }
    return text
  }

  getHistoryCompaniesText (history_companies, gender) {
    let text = ''
    history_companies.sort((a, b) => b.year_start - a.year_start)
    for (let i = 0; i < history_companies.length; i++) {
      if (i > 0) {
        text += '\n'
      }
      let history_company = history_companies[i]
      let history_company_name = history_company.is_discrete ? 'דיסקרטי' : history_company.history_company.name
      const department = history_company.department ? ` ב${history_company.department}` : ''
      if (this.isInternHistoryCompany(history_company)) {
        text += `${gender == 'female' ? 'התמחתה' : 'התמחה'} ב${history_company_name}${department}`
        continue
      }
      let job_title = history_company.job_title == 'עורך דין' ? 'עו"ד' : history_company.job_title
      if (history_company.still_working) {
        text += `החל משנת ${history_company.year_start} ועד היום ${gender == 'female' ? 'עובדת' : 'עובד'} כ${job_title} ב${history_company_name}${department}`
      } else {
        text += `${gender == 'female' ? 'עבדה' : 'עבד'} כ${job_title} בין השנים ${history_company.year_start} ועד ${history_company.year_end} ב${history_company_name}${department}`
      }
    }
    return text
  }

  isInternHistoryCompany (history_company) {
    return history_company.job_title == 'התמחות' || history_company.job_title == 'מתמחה'
  }

  sortHistoryCompanies (a, b) {
    return (this.isInternHistoryCompany(b) - this.isInternHistoryCompany(a)) || a.year_start - b.year_start
  }

  toLowerKeys (obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key]
      return accumulator
    }, {})
  }
}

export default VettingRecipeHelper
